/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { getDashboardData_getDashboardData_salesOutcome as SalesOutComeData } from '../../../gql/types';
import { report_report as ReportResponse } from '../../../gql/types';
import RepComparisonSalesOutcome from '../RepComparisonSalesOutcome';

interface ReportSalesOutcomeWidgetProps {
  data1?: SalesOutComeData | null;
  data2?: SalesOutComeData | null;
  reportData?: ReportResponse | null;
  reportData1?: ReportResponse | null;
}
const useStyles = makeStyles({
  page6MainComponent: {
    marginTop: 8,
    marginLeft: -25,
  },
  page6NextComponent: {
    marginTop: 8,
    marginLeft: -25,
  },
});

const ReportSalesOutcomeWidget: React.FC<ReportSalesOutcomeWidgetProps> = ({
  data1,
  data2,
  reportData,
  reportData1,
}: ReportSalesOutcomeWidgetProps) => {
  const persona = sessionStorage.getItem('persona')
  const numb = persona == 'EXEC' ? 1000 : 1
  const page6SalesOutcomeData = [
    {
      type: 'amount',
      headingName: 'Sales Closed ($ 000)',
      firstPersonTotalValue: data1?.totalSalesClosed?.overallTotalSalesClosed,
      secondPersonTotalValue: data2?.totalSalesClosed?.overallTotalSalesClosed,
      avgValue: reportData?.salesClosed?.avgSalesClosed! * numb,
      maxValue: reportData?.salesClosed?.maxSalesClosed! * numb,
      minValue: reportData?.salesClosed?.minSalesClosed! * numb,
    },
    {
      type: 'dealsClosed',
      headingName: 'Deals Closed',
      firstPersonTotalValue: data1?.noOfDeals,
      secondPersonTotalValue: data2?.noOfDeals,
      avgValue: reportData?.dealsClosed?.avgDealsClosed! * numb,
      maxValue: reportData?.dealsClosed?.maxDealsClosed! * numb,
      minValue: reportData?.dealsClosed?.minDealsClosed! * numb,
    },
    {
      type: 'dealSizeAmount',
      headingName: 'Deal Size ($ 000)',
      firstPersonTotalValue:
        data1?.totalSalesClosed?.overallTotalSalesClosed &&
        data1?.noOfDeals &&
        Math.round(
          data1?.totalSalesClosed?.overallTotalSalesClosed / data1?.noOfDeals,
        ),
      secondPersonTotalValue:
        data2?.totalSalesClosed?.overallTotalSalesClosed &&
        data2?.noOfDeals &&
        Math.round(
          data2?.totalSalesClosed?.overallTotalSalesClosed / data2?.noOfDeals,
        ),
      maxValue: reportData?.dealSize?.maxDealSize,
      minValue: reportData?.dealSize?.minDealSize,
      avgValue: reportData?.dealSize?.avgDealSize,
    },
    {
      type: 'percentage',
      headingName: 'Quota Attainment',
      firstPersonTotalValue:
        data1?.quotaAttainment && Math.round(data1?.quotaAttainment),
      secondPersonTotalValue:
        data2?.quotaAttainment && Math.round(data2?.quotaAttainment),
      avgValue: reportData?.quotaAttainment?.avgQuotaAttainment,
      maxValue: reportData?.quotaAttainment?.maxQuotaAttainment,
      minValue: reportData?.quotaAttainment?.minQuotaAttainment,
    },
    {
      type: 'winRatePercentage',
      headingName: 'Win Rate',
      firstPersonTotalValue: data1?.winRate && Math.round(data1?.winRate),
      secondPersonTotalValue: data2?.winRate && Math.round(data2?.winRate),
      avgValue: reportData?.winRate?.avgWinRate,
      maxValue: reportData?.winRate?.maxWinRate,
      minValue: reportData?.winRate?.minWinRate,
    },
    {
      type: 'days',
      headingName: 'Sales Cycle (Days)',
      firstPersonTotalValue: reportData?.salesCycle?.totalSalesCycle,
      secondPersonTotalValue: reportData1?.salesCycle?.totalSalesCycle,
      avgValue: reportData?.salesCycle?.avgSalesCycle,
      maxValue: reportData?.salesCycle?.maxSalesCycle,
      minValue: reportData?.salesCycle?.minSalesCycle,
    },
  ];

  const classes = useStyles();

  return (
    <Grid container justify="space-between" direction="column">
      {page6SalesOutcomeData.map((item, index) => (
        <Grid
          item
          className={
            index === 0
              ? classes.page6MainComponent
              : classes.page6NextComponent
          }
          key={index}
        >
          <RepComparisonSalesOutcome
            type={item.type}
            firstPersonValue={item.firstPersonTotalValue}
            secondPersonValue={item.secondPersonTotalValue}
            headingName={item.headingName}
            maxValue={item.maxValue}
            minValue={item.minValue}
            avgValue={item.avgValue}
            index={index}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ReportSalesOutcomeWidget;
